/**
 * Inlined at build time via vite `define` (VITE_BUILD_ID).
 * Side effect keeps the stamp in production bundles (minifiers drop `void` on literals).
 * `dataset.viteBuild` is available for support/debugging: document.documentElement.dataset.viteBuild
 */
const stamp: string = import.meta.env.VITE_BUILD_ID;

if (typeof document !== "undefined") {
  document.documentElement.dataset.viteBuild = stamp;
}

export const BUILD_STAMP = stamp;
